export default __webpack_public_path__ + "static/media/message.7c35f045.svg";